/* Receipt upload — for orders placed through Shopify's own checkout with
   Vodafone Cash or InstaPay. The server verifies the phone against the order
   before attaching anything. */
(function () {
  'use strict';

  var form = document.getElementById('du-rc-form');
  if (!form) return;

  var api = (form.dataset.api || '').replace(/\/+$/, '');
  var errEl = document.getElementById('du-rc-error');
  var submitBtn = document.getElementById('du-rc-submit');
  var fileInput = document.getElementById('du-rc-file');
  var previewBox = document.getElementById('du-rc-preview');
  var thumb = document.getElementById('du-rc-thumb');
  var doneEl = document.getElementById('du-rc-done');
  var data = null;

  function fail(msg) {
    errEl.textContent = msg;
    errEl.hidden = false;
    submitBtn.disabled = false;
    submitBtn.textContent = 'Send receipt';
  }

  function clear() {
    data = null;
    fileInput.value = '';
    previewBox.hidden = true;
  }

  // same downscale as the Buy Now form — keeps phone screenshots small
  function shrink(file) {
    return new Promise(function (resolve, reject) {
      var reader = new FileReader();
      reader.onerror = reject;
      reader.onload = function () {
        var img = new Image();
        img.onerror = reject;
        img.onload = function () {
          var max = 1400;
          var scale = Math.min(1, max / Math.max(img.width, img.height));
          var c = document.createElement('canvas');
          c.width = Math.round(img.width * scale);
          c.height = Math.round(img.height * scale);
          c.getContext('2d').drawImage(img, 0, 0, c.width, c.height);
          resolve(c.toDataURL('image/jpeg', 0.82));
        };
        img.src = reader.result;
      };
      reader.readAsDataURL(file);
    });
  }

  fileInput.addEventListener('change', function () {
    var f = fileInput.files && fileInput.files[0];
    if (!f) return clear();
    if (!/^image\//.test(f.type)) { clear(); return fail('Please choose an image file.'); }
    if (f.size > 15 * 1024 * 1024) { clear(); return fail('That image is too large (max 15MB).'); }
    shrink(f).then(function (d) {
      data = d; thumb.src = d; previewBox.hidden = false; errEl.hidden = true;
    }).catch(function () { clear(); fail('We could not read that image.'); });
  });

  document.getElementById('du-rc-remove').addEventListener('click', clear);

  // prefill the order number if they arrived from the thank-you page link
  var qs = new URLSearchParams(location.search);
  if (qs.get('order')) document.getElementById('du-rc-order').value = qs.get('order');

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    errEl.hidden = true;

    var order = document.getElementById('du-rc-order').value.trim();
    var phone = document.getElementById('du-rc-phone').value.trim();
    if (!order) return fail('Please enter your order number.');
    if (phone.replace(/\D/g, '').length < 10) return fail('Please enter the mobile number on your order.');
    if (!data) return fail('Please attach your payment screenshot.');

    submitBtn.disabled = true;
    submitBtn.textContent = 'Sending…';

    fetch(api + '/api/receipt', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ order_name: order, phone: phone, receipt: data })
    })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
      .then(function (res) {
        if (!res.ok || !res.d.ok) return fail(res.d.error || 'Something went wrong. Please try again.');
        form.querySelectorAll('.du-qb__field, .du-qb__receipt, #du-rc-submit, .du-qb__note')
          .forEach(function (el) { el.hidden = true; });
        doneEl.hidden = false;
        document.getElementById('du-rc-done-text').textContent =
          'Thanks — we\'ve attached your receipt to order ' + res.d.order +
          '. We\'ll confirm and dispatch shortly.';
      })
      .catch(function () {
        fail('We could not reach the server. Please try again, or send it on WhatsApp.');
      });
  });
})();
